import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import InterestCalculation from '../InterestCalculation';
import MortgageBreakCalculate from '../MortgageBreakCalculate';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`financial-tabpanel-${index}`}
      aria-labelledby={`financial-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `financial-tab-${index}`,
    'aria-controls': `financial-tabpanel-${index}`,
  };
}

interface FinancialPageProps {
  initialTabKey?: string;
}

type TabKey = 'interest-calculation' | 'mortgage-break-calculate';

export default function FinancialPage({ initialTabKey }: FinancialPageProps) {
  const [value, setValue] = useState(0);

  const tabKeyToIndex = useMemo(() => ({
    'interest-calculation': 0,
    'mortgage-break-calculate': 1,
  } as Record<TabKey, number>), []);

  useEffect(() => {
    if (initialTabKey && initialTabKey in tabKeyToIndex) {
      setValue(tabKeyToIndex[initialTabKey as TabKey]);
    }
  }, [initialTabKey, tabKeyToIndex]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="financial utility tabs">
          <Tab label="Interest Calculation" {...a11yProps(0)} />
          <Tab label="Mortgage Break Calculate" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <InterestCalculation />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MortgageBreakCalculate />
      </TabPanel>
    </Box>
  );
}
